<template>
    <section class="addPromotion">
		<Nav title="添加推广计划" />
		<section class="form_area">
            <van-form @submit="onSubmit">
                <div class="form_group">
                    <van-field
                        v-model="planName"
                        disabled
                        name="planName"
                        label="计划名称"
                        placeholder="请填写计划名称"
                        :rules="[{ required: true, message: '请填写计划名称' }]"
                    />
                    <van-field
                        v-show="false"
                        readonly
                        clickable
                        name="productType"
                        :value="form.productTypeName"
                        label="产品类型"
                        placeholder="请选择产品类型"
                        @click="showProductTypePicker = true"
                        right-icon="arrow-down"
                    />
                    <van-popup v-model="showProductTypePicker" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="productTypeList"
                            @confirm="productTypePickConfirm"
                            @cancel="showProductTypePicker = false"
                        />
                    </van-popup>
                    <van-field name="totalBudgetYuan" label="计划预算（元）">
                        <template #input>
                            <van-stepper v-model="form.totalBudgetYuan" min='2000' max='100000' step='1000' disable-input />
                        </template>
                    </van-field>
                    <!-- <van-field name="dailyBudgetYuan" label="日预算（元）">
                        <template #input>
                            <van-stepper v-model="form.dailyBudgetYuan" min='300' :max='form.totalBudgetYuan' step='50' />
                        </template>
                    </van-field> -->
                    <van-field
                        readonly
                        clickable
                        name="dailyTargetQuantity"
                        :value="form.dailyTargetQuantity"
                        label="日投放量"
                        placeholder="请选择日投放"
                        @click="showDailyTargetQuantityPicker = true"
                        right-icon="arrow-down"
                        :rules="[{ required: true, message: '请选择日投放' }]"
                    />
                    <van-popup v-model="showDailyTargetQuantityPicker" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="dailyTargetQuantityList"
                            @confirm="dailyTargetQuantityPickerConfirm"
                            @cancel="showDailyTargetQuantityPicker = false"
                            :default-index="0"
                            ref="dailyTargetPicker"
                        />
                    </van-popup>
                </div>

                <div class="form_group">
                    <van-field
                        readonly
                        clickable
                        name="cityRange"
                        :value="form.cityRange"
                        label="投放城市"
                        placeholder="请选择投放城市"
                        @click="isCityModel = true"
                        right-icon="arrow-down"
                        :rules="[{ required: true, message: '请选择投放城市' }]"
                    />
                    <van-popup v-model="isCityModel" round position="bottom" class="model_class" >
                        <van-area title="请选择" :area-list="areaList" columns-num="2" @cancel="isCityModel=false" @confirm="confirmCity" />
                    </van-popup>
                    <van-field
                        readonly
                        clickable
                        name="deliveryWeekOption"
                        :value="form.deliveryWeekOptionName"
                        label="投放星期"
                        placeholder="请选择投放星期"
                        @click="showDeliverWeekOptionPicker = true"
                        right-icon="arrow-down"
                        :rules="[{ required: true, message: '请选择投放星期' }]"
                    />
                    <van-popup v-model="showDeliverWeekOptionPicker" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="deliveryWeekOptionList"
                            @confirm="deliverWeekOptionPickConfirm"
                            @cancel="showDeliverWeekOptionPicker = false"
                            :default-index="0"
                        />
                    </van-popup>
                </div>

                <div class="form_group">
                    <van-field
                        readonly
                        clickable
                        name="qualificationFilterCriteria"
                        :value="form.qualificationFilterCriteriaName"
                        label="资质筛选"
                        placeholder="请选择客户资质"
                        @click="showQualificationFilterCriteriaPicker = true"
                        right-icon="arrow-down"
                        :rules="[{ required: true, message: '请选择客户资质' }]"
                    />
                    <van-popup v-model="showQualificationFilterCriteriaPicker" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="qualificationFilterCriteriaList"
                            @confirm="qualificationFilterCriteriaPickConfirm"
                            @cancel="showQualificationFilterCriteriaPicker = false"
                            :default-index="2"
                        />
                    </van-popup>
                </div>

                <div class="form_group">
                    <van-field
                        v-model="estimate.costPerCus"
                        readonly
                        name="costPerCus"
                        label="单价预估"
                        placeholder="请先选择投放条件"
                    />
                    <van-field
                        v-model="estimate.acquireTotal"
                        readonly
                        name="acquireTotal"
                        label="单量预估"
                        placeholder="请先选择投放条件"
                    />
                </div>
                <div class="agreement_wrap">
                    <van-checkbox v-model="agreementChecked" shape="square" icon-size="16px">
                        已阅读并同意
                        <span class="agreement-link" @click="showAgreement">《委托推广协议》</span>
                    </van-checkbox>
                </div>
                <div class="btn_wrap">
                    <van-button round block type="primary" native-type="submit" :disabled="!agreementChecked">提交并支付总预算</van-button>
                </div>
            </van-form>
		</section>
        <section class="tips_area">
            <h3>温馨提示</h3>
            <ol>
                <li>计划预算3000元起，1000元递增，最高100000元；</li>
                <li>每个推广计划只能选择1个投放城市。需添加多城市计划 ，请咨询客服或商务</li>
                <li>资质筛选中“6选1”指的是社保、公积金、车、房、企业主、保单中至少有一项，“3选1”指的是车、房、公积金中至少有一项；</li>
            </ol>
        </section>
	</section>
</template>

<script>
import Nav from "components/Nav";
import { Toast, Dialog } from 'vant';
import {areaList}  from '@vant/area-data';

import promotionServer from "api/promotion";
import settingServer from "api/setting";

import cityConfig from "assets/json/city_config"

export default {
    name: "addPromotion",
	components: {
		Nav,
	},
    data() {
        return {
            form: {
                planName: '',
                productType: 1,
                productTypeName: '信用贷',
                cityRangeType: 1, //特定城市
                cityRange: '',
                planLevel: 2, //竞价层
                billingType: 1, //动态竞价

                totalBudgetYuan: 2000,

                biddingCoefficient: 1,

                channelLevelRange: 2,
                channelLevelRangeArray: [2],

                deliveryWeekOption: 0,
                deliveryWeekOptionName: '周一到周日',

                deliveryTimeOption: 0,
                deliveryTimeOptionName: '00:00~24:00',

                ageRange: 0,
                ageRangeName: '22~59，成本无浮动',

                qualificationFilterCriteria: 2,
                qualificationFilterCriteriaName: '3选1，成本上浮20%',

                dailyTargetQuantity: 15,
                dailyLimit: 15,
            },
            productTypeList: [
                {text:'信用贷'},
                {text:'车抵贷', disabled: true},
                {text:'房抵贷', disabled: true},
                {text:'保单贷', disabled: true},
                {text:'企业贷', disabled: true}
            ],
            deliveryWeekOptionList: [
                {text:'周一到周日'},
                {text:'周一到周五'},
            ],
            deliveryTimeOptionList: [
                {text:'00:00~24:00'},
                {text:'08:00~18:00'},
                {text:'07:00~23:00'},
            ],
            ageRangeList: [
                {text:'22~59，成本无浮动', factor:1},
                {text:'25~55，成本上浮10%', factor:1.1},
                {text:'22~49，成本上浮10%', factor:1.1},
                {text:'30~55，成本上浮20%', factor:1.2},
                {text:'30~50，成本上浮30%', factor:1.3},
                {text:'25~50，成本上浮20%', factor:1.2},
            ],
            qualificationFilterCriteriaList: [
                {text:'无筛选，成本下降10%', factor:0.9, index:0},
                {text:'6选1，成本无浮动', factor:1, index:1},
                {text:'3选1，成本上浮20%',factor:1.2, index:2},
                {text:'必有公积金，成本上浮50%', factor:1.5, index:3},
                {text:'必有车，成本上浮30%', factor:1.3, index:4},
                {text:'必有房，成本上浮40%', factor:1.4, index:5},
                {text:'必是企业主，成本上浮40%', factor:1.4, index:6},
                {text:'有车或有房，成本上浮30%', factor:1.3, index:8},
                {text:'有车或公积金，成本上浮30%', factor:1.3, index:12},
                {text:'有房或公积金，成本上浮40%', factor:1.4, index:13},
            ],
            showProductTypePicker: false,
            showDeliverWeekOptionPicker: false,
            showDeliveryTimeOptionPicker: false,
            showAgeRangePicker: false,
            showQualificationFilterCriteriaPicker: false,

            isCityModel: false,
            areaList,
            datetimeString: this.getFormattedDate(),

            orgInfo: {},

            productBasePrice: 27,
            channelFactor: 1.0,
            cusQualificationScoreFactor: {'min': 0.9, 'max': 1.1},

            dailyTargetQuantityList: [
                {text:15, value:15, disabled:false},
                {text:30, value:30},
                {text:50, value:50},
            ],

            showDailyTargetQuantityPicker: false,

            channelLevelList: [
                { text: 'A级', value: 1, factor:2 , disabled: true},
                { text: 'B级', value: 2, factor:1.0 },
                { text: 'C级', value: 3, factor:0.6 },
            ],

            agreementChecked: false,            
		};
    },

    computed: {
        planName() {
            return this.form.cityRange.slice(0,4) +  '-'
                + this.form.qualificationFilterCriteriaName.split('，')[0]
                + '-' + this.datetimeString
        },

        estimate() {
            let cityFactor = cityConfig.find(item => item.city === this.form.cityRange).pricing_coefficient
            console.log(`city:${this.form.cityRange},cityFactor:${cityFactor}`)

            if (this.form.channelLevelRange)    this.channelFactor = this.channelLevelList.find(item => item.value == this.form.channelLevelRange).factor
            let costPerCusMin = this.productBasePrice * this.channelFactor * cityFactor * this.cusQualificationScoreFactor.min * this.ageRangeList[this.form.ageRange].factor * this.getFactorByIndex(this.form.qualificationFilterCriteria) * 1
            let costPerCusMax = this.productBasePrice * this.channelFactor * cityFactor * this.cusQualificationScoreFactor.max * this.ageRangeList[this.form.ageRange].factor * this.getFactorByIndex(this.form.qualificationFilterCriteria) * this.form.biddingCoefficient
            let costPerCusAvg = (costPerCusMin + costPerCusMax)/2
            let total = (this.form.totalBudgetYuan / costPerCusAvg).toFixed(0)

            let costPerCus = `预计在${costPerCusMin.toFixed(2)}元到${costPerCusMax.toFixed(2)}元之间`
            let acquireTotal = `预计可获取${total}条线索`

            return {'costPerCus': costPerCus, 'acquireTotal':acquireTotal}
        }
    },

    created() {
        this.getInfo()
	},

	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			})
		}
	},	
    methods: {
        getInfo() {
            this.getOrgInfo()
        },

        getOrgInfo() {
            settingServer.getOrgInfo().then((res) => {
                this.orgInfo = res.data
                this.form.cityRange = this.orgInfo.city
            })
        },

        productTypePickConfirm(item, index) {
            this.form.productTypeName = item.text
            this.form.productType = index+1
            this.showProductTypePicker = false
        },

        deliverWeekOptionPickConfirm(item, index) {
            this.form.deliveryWeekOptionName = item.text
            this.form.deliveryWeekOption = index
            this.showDeliverWeekOptionPicker = false
        },

        deliveryTimeOptionPickConfirm(item, index) {
            this.form.deliveryTimeOptionName = item.text
            this.form.deliveryTimeOption = index
            this.showDeliveryTimeOptionPicker = false
        },

        ageRangePickerConfirm(item, index) {
            this.form.ageRangeName = item.text
            this.form.ageRange = index
            this.showAgeRangePicker = false
        },

        qualificationFilterCriteriaPickConfirm(item, index) {
            this.form.qualificationFilterCriteriaName = item.text
            this.form.qualificationFilterCriteria = item.index
            this.showQualificationFilterCriteriaPicker = false
        },

        dailyTargetQuantityPickerConfirm(item, index) {
            this.form.dailyTargetQuantity = item.value
            this.form.dailyLimit = item.value * 1
            console.log(this.form)
            this.showDailyTargetQuantityPicker = false
        },

        onSubmit() {
            if (!this.agreementChecked) {
                Toast('请先阅读并同意《委托推广协议》');
                return;
            }

            this.form.totalBudget = this.form.totalBudgetYuan * 100
            this.form.dailyBudget = this.form.totalBudget
            this.form.planName = this.planName
            console.log(this.form)

            promotionServer.addPromotionPlan(this.form).then((res) => {
                console.log(res)
                if (res.code == 1) {
                    Toast({
                        type: 'loading',
                        message: '添加成功，开始自动支付预算',
                        onClose: ()=>{this.payPlanBudget(res.data)}
                    })
                } else {
                    Toast({
                        type: 'fail',
                        message: '添加失败，在投计划配额不足',
                    })
                }
            })
        },

        payPlanBudget(id) {
            promotionServer.payPlanBudget({id: id}).then((res) => {
                if (res.code == 1) {
                    Dialog.alert({
                        title: '支付成功',
                        message: `预算支付成功\n计划开始推广中`,
                    }).then(() => {
                        this.$router.go(-1)
                    })
                } else {
                    Dialog.confirm({
                        title: '支付失败',
                        message: `余额不足,待支付成功后开始投放计划`,
                        confirmButtonText: '去充值',
                        cancelButtonText: '取消',
                    })
                    .then(() => {
                        // on confirm
                        this.$router.replace({name: 'recharge'})
                    })
                    .catch(() => {
                        // on cancel
                        this.$router.go(-1)
                    })
                }
            })
        },

        cancelCity() {

        },
        
		confirmCity(e) {
            if (this.orgInfo.subscriptionVersion == 1 && e[0].name != this.orgInfo.province) {
                Toast('入门版只能投放本省城市')
            } else {
                this.form.cityRange = e[1].name
			    this.isCityModel = false
            }
		},

        onChannelLevelRangeChange(names) {
            this.form.channelLevelRange = names.join(',')
            console.log(this.form.channelLevelRange)

            if(names[0]==1) {
                this.channelFactor = 1.5
            }

            if(names[0]==2) {
                this.channelFactor = 1.0
            }

            if(names[0]==3) {
                this.channelFactor = 0.65
            }
        },

        onChannelLevelRadioChange(item) {
            if (item==3) {
                Toast('C级渠道日目标量最低30\n已自动调整！')

                this.form.dailyTargetQuantity=30
                this.form.dailyLimit=30
                this.dailyTargetQuantityList[0]['disabled']=true
                this.dailyTargetQuantityList[1]['disabled']=true

                if (this.$refs.dailyTargetPicker) {
                    this.$refs.dailyTargetPicker.setColumnValues(0,this.dailyTargetQuantityList)
                }
            }

            if (item==2) {
                this.form.dailyTargetQuantity=15
                this.form.dailyLimit=15
                this.dailyTargetQuantityList[0]['disabled']=false
                this.dailyTargetQuantityList[1]['disabled']=false

                if (this.$refs.dailyTargetPicker) {
                    this.$refs.dailyTargetPicker.setColumnValues(0,this.dailyTargetQuantityList)
                }
            }
        },

        getFormattedDate() {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);

            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        },

        getFactorByIndex(index) {
            const item = this.qualificationFilterCriteriaList.find(
                (criteria) => criteria.index === index
            );
            
            return item ? item.factor : 1;
        },

        showAgreement() {
            this.$router.push({
                name: 'agreement'
            });
        },

    },
};    
</script>

<style lang="scss">
	.addPromotion {
		padding-top: 46px;
		padding-bottom: 100px;

        .form_area {
            .form_group {
                background-color: #FDFDFD;
                border-radius: 24px;
                margin-bottom: 22px;

                .van-cell {
                    background-color: #FDFDFD;
                }

                .van-cell:first-child {
                    border-radius: 24px 24px 0 0;
                }

                .van-cell:last-child, .van-cell.last {
                    border-radius: 0 0 24px 24px;
                }

                .txt-btn {
                    position: relative;
                    top: -34px;
                    float: right;
                    right: 30px;

                    p {
                        line-height: 24px;
                        font-size: 12px;
                    }

                }
            }

            .agreement_wrap {
                padding: 16px;
                background-color: #FDFDFD;
                border-radius: 24px;
                margin-bottom: 22px;
                text-align: center;

                .van-checkbox {
                    font-size: 14px;
                    color: #4D5B80;
                    line-height: 20px;

                    .agreement-link {
                        color: #098BEF;
                        text-decoration: underline;
                    }
                }
            }

            .btn_wrap {
                position: fixed;
                bottom: 30px;
                width: 100%;
                padding: 0 16px;
            }
        }

        .van-stepper__input {
            width: 48px;
        }

        .tips_area {
            border-radius: 24px;
            background: #FDFDFD;
            padding: 0 0 18px 16px;

            h3 {
                color: #4D5B80;
                font-size: 14px;
                line-height: 22px;
                font-weight: 400;
                font-style: normal;
                padding: 15px 0;
                border-bottom: 1px dotted #E9F0F8;
            }

            ol {
                margin-top: 10px;
                margin-left: 20px;
                margin-right: 30px;
                list-style-type: decimal;

                li {
                    color: #4D5B80;
                    font-size: 13px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    margin-bottom: 4px;
                }
            }
        }
	}
</style>



// WEBPACK FOOTER //
// src/views/promotion/Add.vue